import { useState } from "react";
import Sidebar from "./Sidebar";
import { Menu } from "lucide-react";
import Logo from "./Logo";
import { AnnouncementBanner } from "./AnnouncementBanner";

export default function AppShell({ children, title, eyebrow, actions }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="flex bg-white min-h-screen">
      <Sidebar open={open} onClose={() => setOpen(false)} />
      <main className="flex-1 min-w-0">
        <AnnouncementBanner />
        {/* Mobile top bar */}
        <div className="lg:hidden border-b border-zinc-200 bg-white sticky top-0 z-10 flex items-center justify-between px-4 py-3">
          <button data-testid="mobile-menu-btn" onClick={() => setOpen(true)} className="p-2 -ml-2">
            <Menu className="w-5 h-5" />
          </button>
          <div className="flex items-center gap-2">
            <Logo size={24} />
            <span className="text-base font-black tracking-tighter">VIZIONCAST</span>
          </div>
          <div className="w-9" />
        </div>

        <header className="border-b border-zinc-200 bg-white sticky top-[52px] lg:top-0 z-[5]">
          <div className="px-4 sm:px-6 lg:px-10 py-5 lg:py-6 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
            <div>
              {eyebrow && (
                <div className="text-[10px] sm:text-xs tracking-[0.25em] uppercase text-[#0033FF] font-bold mb-2" data-testid="page-eyebrow">
                  {eyebrow}
                </div>
              )}
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-black tracking-tighter leading-none" data-testid="page-title">{title}</h1>
            </div>
            {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
          </div>
        </header>
        <div className="px-4 sm:px-6 lg:px-10 py-6 lg:py-8">{children}</div>
      </main>
    </div>
  );
}
